<template>
  <div class="relative z-30" ref="calRef" v-if="date">
    <div class="button-group text-sm" v-auto-animate>
      <button @click="useUpdateQuery({ date: prevDate, startDate: undefined, endDate: undefined })">
        <AtomIcon name="chevron-left" />
      </button>
      <button class="!min-w-20 !px-0 !pointer-events-none" :class="{ 'active': isDay }">
        {{ dayjs(date).format('D MMM') }}
      </button>
      <button @click="useUpdateQuery({ date: nextDate, startDate: undefined, endDate: undefined })">
        <AtomIcon name="chevron-right" />
      </button>
    </div>
    <div v-if="showCal" class="absolute z-30 right-0 top-8 bg-white rounded-xl p-4"> 
      <EventsNavCalendar  />
    </div>
  </div>
</template>

<script async setup>
const dayjs = useDayjs()
const route = useRoute()
const calRef = ref(null)
const showCal = ref(false)

// Get specific date
const date = computed(() => route.query?.date)

// Start date, based on query param
const startDate = computed(() => date.value || (route.query?.startDate || dayjs().format('YYYY-MM-DD')))

// Next date & prev date
const prevDate = computed(() => dayjs(startDate.value).add(-1, 'day').format('YYYY-MM-DD'))
const nextDate = computed(() => dayjs(startDate.value).add(1, 'day').format('YYYY-MM-DD'))

// Check active period
const isDay = computed(() => route.query?.date && !route.query?.endDate && !route.query?.endDate)

// Set dates to specific day
const updateDay = (date, value) => {
  useUpdateQuery({ 
    date: dayjs(date).add(value, 'day').format('YYYY-MM-DD'),
    startDate: undefined,
    endDate: undefined,
  })
}

// Handler function for clicks outside calendar
const handleClickOutsideCalendar = (event) => {
  if (calRef.value && !calRef.value.contains(event.target) && showCal.value) {
    // console.log('Close calendar!')
    showCal.value = false
  }
}

// Add event listener when the component is mounted
onMounted(() => document.addEventListener('click', handleClickOutsideCalendar))

// Clean up the event listener when the component is destroyed
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutsideCalendar))

// Watch changes in FAT date to update calendar date
watch(() => route.query, () => {
  showCal.value = false
})
</script>